import React from "react";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";

const LinkChoice = ({ title, choices, selected, onSelect }) => (
  <div className="model-component-main-div order-builder-component">
    <h2 className="order-builder-component-title">{title}</h2>
    <Row>{choices.map((choice) => <Col key={choice.Code} md={6} lg={3} className="border-right">
      <button type="button" className="link-choice-button" onClick={() => onSelect(choice.Code)}>
        <div className={`model-box ${selected === choice.Code ? "active" : ""}`}>
          <div className="model-box-image">{choice.ImagePath && <img src={choice.ImagePath} className="img-fluid" alt="" />}</div>
          <div className="model-box-text"><p>{choice.Name}</p></div>
        </div>
      </button>
    </Col>)}</Row>
  </div>
);

LinkChoice.propTypes = { title: PropTypes.string, choices: PropTypes.array, selected: PropTypes.string, onSelect: PropTypes.func };
export default LinkChoice;
